

// import React, { useState } from 'react';
// import BikeImage from "../assets/BikeImage1.png"; // Adjust the path as necessary

// const Summary = () => {
//   const [isGstChecked, setIsGstChecked] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const handleGstCheckbox = () => {
//     setIsGstChecked((prev) => !prev);
//   };

//   const openDetailsModal = () => {
//     setIsModalOpen(true);
//   };

//   const closeDetailsModal = () => {
//     setIsModalOpen(false);
//   };

//   return (
//     <div className="bg-white p-6 rounded-lg shadow-lg border mt-4 max-w-full ml-12">
//       <h1 className="text-2xl font-bold mb-4 text-left">SUMMARY</h1>
//       <div className="flex items-start">
      
//         <div className="w-1/3 flex flex-col ">
//           <img
//             src={BikeImage}
//             alt="Hero Glamour Xtec 125 N"y
//             className="w-full rounded  "
//           />
//           <p className="text-lg font-semibold mt-2">Hero Glamour Xtec 125 N</p>
//         </div>


//         {/* Right side - Summary details */}
//         <div className="w-2/3 ml-4">
//           {/* Time and Date Row */}
//           <div className="text-sm text-gray-600 mb-4 border-b border-gray-300 pb-2">
//             <div className="flex justify-between">
//               <span>03:30 pm</span>
//               <span>08:30 am</span>
//             </div>
//             <div className="flex justify-between">
//               <span>10 OCT 2024</span>
//               <span>17 OCT 2024</span>
//             </div>
//           </div>

//           {/* Location Row */}
//           <div className="flex justify-between items-center text-sm text-gray-800 mb-2">
//             <p>Location:</p>
//             <p className="font-semibold">Camp Belagavi</p>
//           </div>

//           {/* Bike Model and Price Row with Border */}
//           <div className="flex justify-between items-center text-sm text-gray-800 mb-4 border-b border-gray-300 pb-2">
//             <p>Hero Glamour Xtec 125 N</p>
//             <p className="font-semibold text-gray-800">₹450.00</p>
//           </div>

//           {/* Accessories Row */}
//           <div className="text-sm text-gray-800 mb-4 ">
//             <div className="flex justify-between items-center">
//               <p>Accessories</p>
//               <button className="text-blue-500 underline">Edit</button>
//             </div>
//             <div className="border rounded p-2 w-full mt-2">
//               <div className="flex justify-between ">
//                 <span>2 Regular Helmet</span>
//                 <span>₹100.00</span>
//               </div>
//               <div className="flex justify-between">
//                 <span>2 Regular Jacket</span>
//                 <span>₹300.00</span>
//               </div>
//             </div>
//           </div>


//           <div className="text-sm text-gray-800 mb-4 text-left">
//             <p>Wallet</p>
//             <div className="border rounded p-2 w-full mt-2">
//               <p>MoveonWheels Points</p>
//               <div className="flex items-center justify-between">
//                 <label className="flex items-center">
//                   <input type="checkbox" className="mr-2" />
//                   You are eligible to use ₹100.00 of ₹100.00
//                 </label>
//                 {/* Details button aligned to the right */}
//                <button
//                   className="text-[#FF9630] underline"
//                   onClick={openDetailsModal}
//                 >
//                   Details
//                 </button>  </div>
//             </div>
//             {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white rounded-lg shadow-lg w-full h-[70%] md:w-2/3 md:h-[68%] overflow-y-auto">
//             <div className="bg-[#FF9630] text-white text-center text-lg font-bold py-4 rounded-t-lg">
//               Moveonwheels Points
//             </div>
//             <div className="p-6 space-y-4 text-gray-800">
//               <ul className="list-disc pl-5 text-lg mt-8">
//                 <li>
//                   Overspeeding fine of Rs. 500 is applicable after every 3
//                   counts of overspeeding. This is exclusive of taxes and any
//                   other fines applied by the governing authority.
//                 </li>
//                 <li>
//                   THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF
//                   AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE
//                   AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS /
//                   RECORDS IN VARIOUS STATUTES. THESE TERMS OF SERVICES DOES NOT
//                   REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.
//                 </li>
//               </ul>
//             </div>
//             <div className="text-center m-10">
//               <button
//                 className="bg-[#FF9630] hover:bg-[#FF9630] text-white w-full p-6 font-semibold py-3 px-6 rounded"
//                 onClick={closeDetailsModal}
//               >
//                 OKAY
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
    
//           </div>
          

//           {/* Insurance Section */}
//           <p>Insurance</p>
//           <div className="text-sm text-gray-800 mb-4 text-left border rounded p-2 w-full mt-2">
//             <div className="flex items-center">
//               <input type="checkbox" className="mr-2" />
//               <span>MoveonWheels Insurance</span>
//               <span className="ml-auto">₹2.00/hr</span>
//             </div>
//           </div>

//           {/* GST Section */}
//           <div className="text-sm text-gray-800 mb-4 text-left">
//             <p>I have GST Number (Optional)</p>
//             <div className="flex items-center text-sm md:text-base border p-2 rounded-md">
//               <input
//                 type="checkbox"
//                 className="mr-2"
//                 onChange={handleGstCheckbox}
//                 checked={isGstChecked}
//               />
//               <span className="text-gray-600">GST IN</span>
//             </div>


//             {isGstChecked && (
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
//                 <div>
//                   <input
//                     type="text"
//                     id="gstin"
//                     className="mt-1 p-2 block w-full border rounded-md"
//                     placeholder="Enter GST IN"
//                   />
//                 </div>
//                 <div>
//                   <input
//                     type="text"
//                     id="businessName"
//                     className="mt-1 p-2 block w-full border rounded-md"
//                     placeholder="Enter Business Name"
//                   />
//                 </div>
//                 <div>
//                   <input
//                     type="text"
//                     id="businessAddress"
//                     className="mt-1 p-2 block w-full border rounded-md"
//                     placeholder="Enter Business Address"
//                   />
//                 </div>
//                 <div>
//                   <input
//                     type="email"
//                     id="businessEmail"
//                     className="mt-1 p-2 block w-full border rounded-md"
//                     placeholder="Enter Business Email"
//                   />
//                 </div>
//               </div>
//             )}
//             <div className="flex items-center space-x-4 mt-2">
//               <input
//                 type="text"
//                 className="border rounded p-2 w-3/4"
//                 placeholder="Enter Code"
//               />

//               <button className="bg-[#FF9630] text-white font-semibold px-4 py-2 rounded w-1/4">
//                 APPLY
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Summary;


import React, { useState } from 'react';
import BikeImage from "../assets/BikeImage1.png"; // Adjust the path as necessary

const Summary = () => {
  const [isGstChecked, setIsGstChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleGstCheckbox = () => {
    setIsGstChecked((prev) => !prev);
  };

  const openDetailsModal = () => {
    setIsModalOpen(true);
  };

  const closeDetailsModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg border mt-4 max-w-full md:ml-12">
      <h1 className="text-2xl font-bold mb-4 text-left">SUMMARY</h1>
      
      {/* Updated Flex Layout for Responsiveness */}
      <div className="flex flex-col md:flex-row items-start">
        
        {/* Image Section */}
        <div className="w-full md:w-1/3 mb-4 md:mb-0">
          <img
            src={BikeImage}
            alt="Hero Glamour Xtec 125 N"
            className="w-full rounded"
          />
          <p className="text-lg font-semibold mt-2">Hero Glamour Xtec 125 N</p>
        </div>

        {/* Right side - Summary details */}
        <div className="w-full md:w-2/3 md:ml-4">
          {/* Time and Date Row */}
          <div className="text-sm text-gray-600 mb-4 border-b border-gray-300 pb-2">
            <div className="flex justify-between">
              <span>03:30 pm</span>
              <span>08:30 am</span>
            </div>
            <div className="flex justify-between">
              <span>10 OCT 2024</span>
              <span>17 OCT 2024</span>
            </div>
          </div>

          {/* Location Row */}
          <div className="flex justify-between items-center text-sm text-gray-800 mb-2">
            <p>Location:</p>
            <p className="font-semibold">Camp Belagavi</p>
          </div>

          {/* Bike Model and Price Row with Border */}
          <div className="flex justify-between items-center text-sm text-gray-800 mb-4 border-b border-gray-300 pb-2">
            <p>Hero Glamour Xtec 125 N</p>
            <p className="font-semibold text-gray-800">₹450.00</p>
          </div>

          {/* Accessories Row */}
          <div className="text-sm text-gray-800 mb-4">
            <div className="flex justify-between items-center">
              <p>Accessories</p>
              <button className="text-blue-500 underline">Edit</button>
            </div>
            <div className="border rounded p-2 w-full mt-2">
              <div className="flex justify-between">
                <span>2 Regular Helmet</span>
                <span>₹100.00</span>
              </div>
              <div className="flex justify-between">
                <span>2 Regular Jacket</span>
                <span>₹300.00</span>
              </div>
            </div>
          </div>

          {/* Wallet Section */}
          <div className="text-sm text-gray-800 mb-4 text-left">
            <p>Wallet</p>
            <div className="border rounded p-2 w-full mt-2">
              <p>MoveonWheels Points</p>
              <div className="flex items-center justify-between">
                <label className="flex items-center">
                  <input type="checkbox" className="mr-2" />
                  You are eligible to use ₹100.00 of ₹100.00
                </label>
                <button className="text-[#FF9630] underline" onClick={openDetailsModal}>
                  Details
                </button>
              </div>
            </div>

            {isModalOpen && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
                <div className="bg-white rounded-lg shadow-lg w-full h-[70%] md:w-2/3 md:h-[68%] overflow-y-auto">
                  <div className="bg-[#FF9630] text-white text-center text-lg font-bold py-4 rounded-t-lg">
                    Moveonwheels Points
                  </div>
                  <div className="p-6 space-y-4 text-gray-800">
                    <ul className="list-disc pl-5 text-lg mt-8">
                      <li>
                        Overspeeding fine of Rs. 500 is applicable after every 3 counts of overspeeding. This is exclusive of taxes and any other fines applied by the governing authority.
                      </li>
                      <li>
                        THESE TERMS OF SERVICES IS AN ELECTRONIC RECORD IN THE FORM OF AN ELECTRONIC CONTRACT FORMED UNDER APPLICABLE LAWS THE AMENDED PROVISIONS PERTAINING TO ELECTRONIC DOCUMENTS / RECORDS IN VARIOUS STATUTES. THESE TERMS OF SERVICES DOES NOT REQUIRE ANY PHYSICAL, ELECTRONIC OR DIGITAL SIGNATURE.
                      </li>
                    </ul>
                  </div>
                  <div className="text-center m-10">
                    <button className="bg-[#FF9630] hover:bg-[#FF9630] text-white w-full p-6 font-semibold py-3 px-6 rounded" onClick={closeDetailsModal}>
                      OKAY
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Insurance Section */}
          <p>Insurance</p>
          <div className="text-sm text-gray-800 mb-4 text-left border rounded p-2 w-full mt-2">
            <div className="flex items-center">
              <input type="checkbox" className="mr-2" />
              <span>MoveonWheels Insurance</span>
              <span className="ml-auto">₹2.00/hr</span>
            </div>
          </div>

          {/* GST Section */}
          <div className="text-sm text-gray-800 mb-4 text-left">
            <p>I have GST Number (Optional)</p>
            <div className="flex items-center text-sm md:text-base border p-2 rounded-md">
              <input type="checkbox" className="mr-2" onChange={handleGstCheckbox} checked={isGstChecked} />
              <span className="text-gray-600">GST IN</span>
            </div>

            {isGstChecked && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                <input type="text" id="gstin" className="mt-1 p-2 block w-full border rounded-md" placeholder="Enter GST IN" />
                <input type="text" id="businessName" className="mt-1 p-2 block w-full border rounded-md" placeholder="Enter Business Name" />
                <input type="text" id="businessAddress" className="mt-1 p-2 block w-full border rounded-md" placeholder="Enter Business Address" />
                <input type="email" id="businessEmail" className="mt-1 p-2 block w-full border rounded-md" placeholder="Enter Business Email" />
              </div>
            )}

            <div className="flex items-center space-x-4 mt-2">
              <input type="text" className="border rounded p-2 w-3/4" placeholder="Enter Code" />
              <button className="bg-[#FF9630] text-white font-semibold px-4 py-2 rounded w-1/4">APPLY</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summary;
